import { strCode } from "../localizations/strCode";

export const dashboardTabs = [
  { id: "kit", title: strCode.KIT_LABEL },
  { id: "charger", title: strCode.CHARGER_LABEL },
  { id: "holder", title: strCode.HOLDER_LABEL }
];
